import { render, staticRenderFns } from "./TopEmployeesByRevenuesChart.vue?vue&type=template&id=6ebb09b0&"
import script from "./TopEmployeesByRevenuesChart.vue?vue&type=script&lang=js&"
export * from "./TopEmployeesByRevenuesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports